import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, H4 } from '@bigcommerce/big-design';

import { assignmentDelete } from '../../redux/actions/assignments';

const DeleteAssignmentModal = ({ payload, supplierId, showDeleteAssignmentModal, setShowDeleteAssignmentModal, assignment, assignmentName, deleteAssignment }) => {
  const update = () => {
    deleteAssignment(payload, supplierId, assignment)
    setShowDeleteAssignmentModal(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowDeleteAssignmentModal(false),
        },
        { text: 'Remove Assignment', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Remove Assignment"
      isOpen={showDeleteAssignmentModal}
      onClose={() => setShowDeleteAssignmentModal(false)}
    >
      <H3>{assignmentName}</H3>
      <H4>Curent Supplier Price</H4>
      {assignment?.supplier_price}

      <H4>Curent Minimum Order Quantity</H4>
      {assignment?.minimum_order}
    </Modal>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  deleteAssignment: (payload, supplierId, assignment) => dispatch(assignmentDelete(payload, supplierId, assignment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAssignmentModal);